import { useTranslation } from "react-i18next"
import { TFunction } from "i18next"
import { Checkbox } from "antd"
import { InputType } from "../../../components/TextInput/const/InputType.enum"

export default (onSelectAll?: (value: boolean) => void) => {
	const { t } = useTranslation("payments", { keyPrefix: "dataTableHeaders" })

	return columns(t, onSelectAll)
}

const columns = (t: TFunction, onSelectAll?: (value: boolean) => void) => [
	{
		key: "id",
		title: "ID",
		dataIndex: "id",
		width: "4rem",
		align: "center"
	},
	{
		key: "sellerName",
		title: t("sellerName"),
		dataIndex: "sellerName",
		align: "center",
		width: "10rem",
		ellipsis: true
	},
	{
		key: "invoiceNumber",
		title: t("invoiceNumber"),
		dataIndex: "invoiceNumber",
		align: "center",
		width: "10rem"
	},
	{
		key: "period",
		title: t("period"),
		dataIndex: "period",
		align: "center",
		width: "5rem"
	},
	{
		key: "emissionDate",
		title: t("emissionDate"),
		dataIndex: "emissionDate",
		align: "center",
		width: "10rem"
	},
	{
		key: "sellerPrice",
		title: t("sellerPrice"),
		dataIndex: "sellerPrice",
		align: "center",
		width: "8rem"
	},
	{
		key: "totalFee",
		title: t("totalFee"),
		dataIndex: "totalFee",
		align: "center",
		width: "8rem"
	},
	{
		key: "total",
		title: t("total"),
		dataIndex: "total",
		align: "center",
		width: "8rem"
	},
	{
		key: "sellerPayment",
		title: t("sellerPayment"),
		dataIndex: "sellerPayment",
		align: "center",
		width: "8rem"
	},
	{
		key: "sellerPaymentDate",
		title: t("sellerPaymentDate"),
		dataIndex: "sellerPaymentDate",
		align: "center",
		width: "12rem"
	},
	{
		key: "feeException",
		title: t("feeException"),
		dataIndex: "feeException",
		align: "center",
		width: "8rem"
	},
	{
		key: "collectionAmount",
		title: t("collectionAmount"),
		dataIndex: "collectionAmount",
		align: "center",
		width: "8rem"
	},
	{
		key: "collected",
		title: t("collected"),
		dataIndex: "collected",
		align: "center",
		width: "8rem"
	},
	{
		key: "sellerCollectionDate",
		title: t("sellerCollectionDate"),
		dataIndex: "sellerCollectionDate",
		align: "center",
		width: "12rem"
	}
]
